import { useTranslation } from "react-i18next";
import { ReactEventHandler } from "react";
import { IconArrowLink } from "../../../../common/icons/IconArrowLink/IconArrowLink";
import ApplicantItem from "../ApplicantItem/ApplicantItem";
import { ABOInfo, PartyInfo, ProfileInfo } from "../../../../services/Profile/profileAPI.types";
import "./ApplicantCard.scss";
import "../ApplicantItem/ApplicantItem.scss";
import defaultContent from "../../../../content/profile";

type Props = {
  aboInfo: ABOInfo;
  partyInfo: PartyInfo[];
  viewAllLinkOnclick: ReactEventHandler;
  applicantTrackOnclick: (event: string) => void;
  profileInfo: Partial<ProfileInfo>;
};

const ApplicantCard = (props: Props) => {
  const { t } = useTranslation(["profile"]);

  const { aboInfo, partyInfo, viewAllLinkOnclick, applicantTrackOnclick, profileInfo } = props;
  const { privacyFlag } = aboInfo;
  const primaryParty = partyInfo.find(({ isPrimary }) => isPrimary === true) || partyInfo[0];
  const numberOfApplicant = partyInfo.length;

  const ViewAllLink = () =>
    privacyFlag === false ? (
      <div className="leaf-applicant-card__view-all">
        <div className="leaf-applicant-card__line"></div>
        <div
          className="leaf-applicant-card__footer"
          onClick={viewAllLinkOnclick}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              viewAllLinkOnclick(e);
            }
          }}
          tabIndex={0}
          role="button"
        >
          <div className="leaf-applicant-card__footer--view-link">
            {t("aboProfile.aboApplicants.viewAllLink", defaultContent["aboProfile"]["aboApplicants"]["viewAllLink"], {
              NUMBER: numberOfApplicant,
            })}
          </div>
          <div>
            <IconArrowLink />
          </div>
        </div>
      </div>
    ) : (
      <></>
    );

  return numberOfApplicant > 0 ? (
    <div className="leaf-applicant-card">
      <ApplicantItem
        aboInfo={aboInfo}
        partyInfo={primaryParty}
        isExpandable={false}
        applicantTrackOnclick={applicantTrackOnclick}
        profileInfo={profileInfo}
      />
      <ViewAllLink />
    </div>
  ) : (
    <></>
  );
};

export default ApplicantCard;
